export default __webpack_public_path__ + "static/cercle_vicieux_uw_de-7ca34c4a771626ead912fb3d5625093f.mp4";